import React, { useMemo, useState } from 'react';

const selectWrapStyle = {
  display: 'grid',
  gap: '0.35rem',
  boxSizing: 'border-box',
  minWidth: 0,
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
};

const controlStyle = {
  boxSizing: 'border-box',
  minWidth: 0,
  width: '100%',
  maxWidth: '100%',
};

const selectStyle = {
  ...controlStyle,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const helperStyle = {
  color: '#6b7280',
  fontSize: '0.82rem',
  lineHeight: 1.25,
};

const getFacilityLabel = (facility) => `${facility.id} - ${facility.name || 'Unnamed facility'}`;

const SearchableFacilitySelect = ({
  facilities,
  options,
  value,
  onChange,
  required = false,
  disabled = false,
  placeholder = 'Search facility by id, name, county',
  emptyLabel = 'Select facility',
  helperLabel = 'facilities',
  getOptionValue = (facility) => facility.id,
  getOptionLabel = getFacilityLabel,
  getSearchText,
  className,
}) => {
  const [search, setSearch] = useState('');
  const items = useMemo(() => options || facilities || [], [options, facilities]);
  const selectedItem = useMemo(
    () => items.find((item) => String(getOptionValue(item)) === String(value)),
    [getOptionValue, items, value],
  );

  const filteredItems = useMemo(() => {
    const term = search.trim().toLowerCase();
    const selectedItem = items.find((item) => String(getOptionValue(item)) === String(value));
    const matches = term
      ? items.filter((item) => {
        const searchableText = getSearchText
          ? getSearchText(item)
          : [
            getOptionValue(item),
            item.name,
            item.county,
            item.subcounty,
            item.ward,
            item.hmis,
          ].join(' ');

        return searchableText.toString().toLowerCase().includes(term);
      })
      : items;

    if (
      selectedItem &&
      !matches.some((item) => String(getOptionValue(item)) === String(getOptionValue(selectedItem)))
    ) {
      return [selectedItem, ...matches];
    }
    return matches;
  }, [getOptionValue, getSearchText, items, search, value]);

  return (
    <div className={className} style={selectWrapStyle}>
      <input
        type="search"
        style={controlStyle}
        placeholder={placeholder}
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        disabled={disabled}
      />
      <select
        style={selectStyle}
        title={selectedItem ? getOptionLabel(selectedItem) : emptyLabel}
        required={required}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
      >
        <option value="">{emptyLabel}</option>
        {filteredItems.map((item) => (
          <option key={getOptionValue(item)} value={getOptionValue(item)}>
            {getOptionLabel(item)}
          </option>
        ))}
      </select>
      <span style={helperStyle}>
        Showing {filteredItems.length} of {items.length} {helperLabel}
      </span>
    </div>
  );
};

export default SearchableFacilitySelect;
